import axios from "axios";
import React, { useState } from "react";
import { HUBSPOT_PROXY_URL } from "../constants";
import { footerTheme } from "../partials/Footer";
import { handleHubSpotError } from "./hubspotErrorHandler";

const formTheme = {
  default: {
    containerClasses:
      "relative flex items-center max-w-xs rounded-full overflow-hidden shadow-card border-none",
    inputClasses:
      "h-11 w-full px-3 py-2.5 text-sm lg:text-base text-gray-800 border-none rounded-none focus:ring-white focus:border-white placeholder:text-gray-2200",
    buttonContainerClasses: "bg-white",
    buttonClasses: "bg-purple-1500 py-2 rounded-full my-[3px]",
    buttonIconClasses: "size-5",
    buttonText: "",
    successClasses: "mt-2 text-sm text-green-600",
    errorClasses: "mt-2 text-sm text-red-600",
    placeholder: "Your work email",
  },
  footerNewDesign: {
    // Desktop: inline layout
    containerClasses:
      "hidden relative md:flex flex-row items-center justify-between pl-5 pr-2 py-[5px] bg-gray-2800 rounded-[40px] relative w-full max-w-[360px] border border-[#eaeaea]",
    // Mobile: stacked layout
    mobileContainerClasses: "flex relative md:hidden flex-col gap-3 w-full",
    mobileInputContainerClasses:
      "bg-gray-2800 flex flex-row items-center justify-center px-4 h-11 rounded-[40px] border border-[#eaeaea] w-full",
    inputClasses:
      "flex-1 border-0 bg-transparent font-['Inter'] font-normal text-base md:text-sm lg:text-base text-[#8c8c8c] placeholder-[#8c8c8c] outline-none focus:outline-none focus:ring-0 focus:border-none tracking-[-0.4px] leading-6",
    mobileInputClasses:
      "flex-1 border-0 bg-transparent font-['Inter'] font-normal text-base text-[#959595] placeholder-[#959595] outline-none focus:outline-none focus:ring-0 focus:border-none tracking-[-0.4px] leading-6 text-center",
    buttonContainerClasses: "",
    buttonClasses:
      "absolute right-0 h-full px-4 py-[15px] bg-[#5e44ff] text-white rounded-br-[40px] rounded-tr-[40px] font-manrope font-semibold text-lg cursor-pointer transition-all duration-300 whitespace-nowrap tracking-[-0.45px] leading-7 hover:bg-[#4a35cc] flex items-center justify-center",
    mobileButtonClasses:
      "px-5 py-2 bg-[#5e44ff] text-white rounded-[40px] font-['Manrope'] font-semibold text-lg cursor-pointer transition-all duration-300 whitespace-nowrap tracking-[-0.45px] leading-7 hover:bg-[#4a35cc] w-full text-center flex items-center justify-center",
    buttonIconClasses: "w-4 h-4 w-[40px]",
    buttonText: "",
    mobileButtonText: "Subscribe now",
    successClasses: "mt-2 text-sm text-green-600",
    errorClasses: "mt-2 text-sm text-red-600",
    placeholder: "Enter your work email",
  },
  heroWeiwei: {
    // Desktop: inline layout with purple border
    containerClasses:
      "hidden md:flex flex-row items-center justify-between pl-6 pr-2 py-1.5 bg-neutral-50 rounded-[40px] relative w-full max-w-lg",
    // Mobile: stacked layout
    mobileContainerClasses: "flex md:hidden flex-col gap-3 w-full",
    mobileInputContainerClasses:
      "bg-neutral-50 flex flex-row items-center justify-between px-4 rounded-[40px] border border-[#eaeaea] w-full",
    inputClasses:
      "flex-1 border-0 bg-transparent font-['Inter'] font-normal text-base text-[#8c8c8c] placeholder-[#8c8c8c] outline-none focus:outline-none tracking-[-0.4px] leading-6",
    mobileInputClasses:
      "flex-1 border-0 bg-transparent font-['Inter'] font-normal text-base text-[#959595] placeholder-[#959595] outline-none focus:outline-none tracking-[-0.4px] leading-6 text-center",
    buttonContainerClasses: "",
    buttonClasses:
      "px-4 py-2 bg-[#5e44ff] text-white rounded-[40px] font-['Manrope'] font-semibold text-base cursor-pointer transition-all duration-300 whitespace-nowrap tracking-[-0.4px] leading-6 hover:bg-[#4a35cc]",
    mobileButtonClasses:
      "px-4 py-2 bg-[#5e44ff] text-white rounded-[40px] font-['Manrope'] font-semibold text-base cursor-pointer transition-all duration-300 whitespace-nowrap tracking-[-0.4px] leading-6 hover:bg-[#4a35cc] w-full text-center",
    buttonIconClasses: "hidden",
    buttonText: "Subscribe",
    mobileButtonText: "Subscribe now",
    successClasses: "mt-2 text-sm text-green-600",
    errorClasses: "mt-2 text-sm text-red-600",
    placeholder: "Enter your email address",
  },
  heroKusama: {
    containerClasses: "flex flex-col w-full sm:flex-1 sm:min-w-0 sm:max-w-[474px]",
    formClasses: "w-full relative flex flex-col gap-3 mb-4 sm:flex-row",
    inputContainerClasses: "relative border !rounded-4xl",
    inputClasses:
      "w-full border-none text-gray-2500 focus:placeholder:text-gray-2200 placeholder-gray-600 text-left focus:rounded-4xl rounded-4xl focus:!shadow-none focus:!outline-none focus:ring-0 focus:!border-none placeholder:text-base placeholder:tracking-[-0.8px] leading-6 disabled:bg-gray-300 bg-white pl-4 sm:pl-[22px] pr-4 sm:pr-32 py-2 sm:py-3.5 ring-0 focus:ring-0 focus:border-none",
    buttonContainerClasses:
      "sm:absolute right-1.5 top-1/2 sm:-translate-y-1/2 mt-3 sm:mt-0",
    buttonClasses:
      "disabled:cursor-not-allowed justify-center flex gap-1 items-center px-4 py-2 w-full sm:w-auto whitespace-nowrap font-manrope tracking-[-0.4px] text-white bg-purple-1500 shrink-0 rounded-4xl font-semibold",
    buttonIconClasses: "hidden",
    buttonText: "Subscribe",
    successClasses: "mt-2 text-sm text-green-600",
    errorClasses: "mt-2 text-sm text-red-600",
    placeholder: "Enter your email address",
  },
};

const SignUpForm = ({ subscribe, theme = "default", variant = "default", formId = "7a9fb3d8-2bac-4efd-9c4c-186560ce075c" }) => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submittedState, setSubmittedState] = useState("none");

  const subscribeToNewsLetter = async (e) => {
    try {
      e.preventDefault();
      setMessage("");
      setSubmittedState("loading");
      const [cookie] = document.cookie
        .split("; ")
        .filter((x) => x.includes("hubspotutk="));
      const [, hubspotutk] = cookie?.split("=") || ["", ""];

      if (email.length < 3) {
        setSubmittedState("none");
        return false;
      }

      const requestPayload = {
        fields: [
          {
            objectTypeId: "0-1",
            name: "email",
            value: email,
          },
        ],
        context: {
          pageUri: location?.href,
          pageName: location?.pathname,
        },
      };

      if (hubspotutk) {
        requestPayload.context.hutk = hubspotutk;
      }

      const res = await axios.post(
        HUBSPOT_PROXY_URL,
        Object.assign(requestPayload, {
          portalId: "25381551",
          formId: formId,
        }),
      );

      setSubmittedState("success");
      setEmail("");
      setMessage(res?.data?.inlineMessage || "Thanks for subscribing!");
    } catch (error) {
      const errorMessage = handleHubSpotError(error);
      setMessage(errorMessage);
      setSubmittedState("error");
    }
  };

  const currentTheme = formTheme[variant] || formTheme.default;
  const isHeroWeiwei = variant === "heroWeiwei";
  const isHeroKusama = variant === "heroKusama";
  const isFooterNewDesign = variant === "footerNewDesign";

  if (isFooterNewDesign) {
    return (
      <div className="w-full">
        {/* Desktop Layout */}
        <form
          className={currentTheme.containerClasses}
          onSubmit={(e) => subscribeToNewsLetter(e)}
        >
          <input
            aria-label="email"
            type="email"
            name="EMAIL"
            className={currentTheme.inputClasses}
            placeholder={currentTheme.placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className={currentTheme.buttonClasses}
            aria-label="Subscribe"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="white"
              role="presentation"
              className={currentTheme.buttonIconClasses}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
              />
            </svg>
          </button>
        </form>

        {/* Mobile Layout */}
        <form
          className={currentTheme.mobileContainerClasses}
          onSubmit={(e) => subscribeToNewsLetter(e)}
        >
          <div className={currentTheme.mobileInputContainerClasses}>
            <input
              aria-label="email"
              type="email"
              name="EMAIL"
              className={currentTheme.mobileInputClasses}
              placeholder={currentTheme.placeholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className={currentTheme.mobileButtonClasses}
            aria-label="Subscribe"
          >
            {currentTheme.mobileButtonText}
          </button>
        </form>

        {/* Success/Error Messages */}
        {submittedState === "success" && (
          <p className={currentTheme.successClasses}>
            {subscribe ? (
              <div>
                {message ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: message,
                    }}
                  />
                ) : (
                  "Thanks for subscribing!"
                )}
              </div>
            ) : (
              "Thanks for subscribing!"
            )}
          </p>
        )}
        {submittedState === "error" && (
          <p className={currentTheme.errorClasses}>{message}</p>
        )}
      </div>
    );
  }

  if (isHeroWeiwei) {
    return (
      <div className="w-full">
        {/* Desktop Layout */}
        <form
          className={currentTheme.containerClasses}
          onSubmit={(e) => subscribeToNewsLetter(e)}
        >
          <input
            aria-label="email"
            type="email"
            name="EMAIL"
            className={currentTheme.inputClasses}
            placeholder={currentTheme.placeholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button
            type="submit"
            className={currentTheme.buttonClasses}
            aria-label="Subscribe"
          >
            {currentTheme.buttonText}
          </button>
        </form>

        {/* Mobile Layout */}
        <form
          className={currentTheme.mobileContainerClasses}
          onSubmit={(e) => subscribeToNewsLetter(e)}
        >
          <div className={currentTheme.mobileInputContainerClasses}>
            <input
              aria-label="email"
              type="email"
              name="EMAIL"
              className={currentTheme.mobileInputClasses}
              placeholder={currentTheme.placeholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className={currentTheme.mobileButtonClasses}
            aria-label="Subscribe"
          >
            {currentTheme.mobileButtonText}
          </button>
        </form>

        {/* Success/Error Messages */}
        {submittedState === "success" && (
          <p className={currentTheme.successClasses}>
            {subscribe ? (
              <div>
                {message ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: message,
                    }}
                  />
                ) : (
                  "Thanks for subscribing!"
                )}
              </div>
            ) : (
              "Thanks for subscribing!"
            )}
          </p>
        )}
        {submittedState === "error" && (
          <p className={currentTheme.errorClasses}>{message}</p>
        )}
      </div>
    );
  }

  if (isHeroKusama) {
    return (
      <section className={currentTheme.containerClasses}>
        <form
          className={currentTheme.formClasses}
          onSubmit={(e) => subscribeToNewsLetter(e)}
        >
          <div className="relative w-full">
            <div className={currentTheme.inputContainerClasses}>
              <input
                aria-label="email"
                type="email"
                name="EMAIL"
                className={currentTheme.inputClasses}
                placeholder={currentTheme.placeholder}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className={currentTheme.buttonContainerClasses}>
              <div className="cta-actions">
                <button
                  aria-label="submit"
                  type="submit"
                  disabled={submittedState === "loading"}
                  className={currentTheme.buttonClasses}
                >
                  <span className="inline-block">{currentTheme.buttonText}</span>
                  {submittedState === "loading" && (
                    <svg
                      className="w-5 h-5 text-white animate-spin"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      role="presentation"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                  )}
                </button>
              </div>
            </div>
          </div>
        </form>
        {/* Success/Error Messages */}
        {submittedState === "success" && (
          <p className={currentTheme.successClasses}>
            {subscribe ? (
              <div>
                {message ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: message,
                    }}
                  />
                ) : (
                  "Thanks for subscribing!"
                )}
              </div>
            ) : (
              "Thanks for subscribing!"
            )}
          </p>
        )}
        {submittedState === "error" && (
          <p className={currentTheme.errorClasses}>Something went wrong</p>
        )}
      </section>
    );
  }

  // Default variant (unchanged)
  return (
    <div>
      <div className="flex flex-wrap mb-4">
        <div className="w-full">
          <label className="block text-sm sr-only" htmlFor="newsletter">
            Email
          </label>
          <form
            className={`${footerTheme[theme]?.subFormContainerCalsses}`}
            onSubmit={(e) => subscribeToNewsLetter(e)}
          >
            <input
              aria-label="email"
              type="email"
              name="EMAIL"
              className="h-11 w-full px-3 py-2.5 text-sm lg:text-base text-gray-800 border-none rounded-none focus:ring-white focus:border-white placeholder:text-gray-2200"
              placeholder={currentTheme.placeholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <div className="bg-white">
              <button
                type="submit"
                className="bg-purple-1500 px-3 py-2 rounded-full mx-[5px] my-[3px]"
                aria-label="Subscribe"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="white"
                  role="presentation"
                  className="size-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
                  />
                </svg>
              </button>
            </div>
          </form>
          {submittedState === "success" && (
            <p className={currentTheme.successClasses}>
              {subscribe ? (
                <div>
                  {message ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: message,
                      }}
                    />
                  ) : (
                    "Thanks for subscribing!"
                  )}
                </div>
              ) : (
                "Thanks for subscribing!"
              )}
            </p>
          )}
                  {submittedState === "error" && (
          <p className={currentTheme.errorClasses}>{message}</p>
        )}
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;
